// Constants
import { AnalyticsConstants } from '../../constants.js'

// Utilities
import Analytics from '../../utility/analyticsUtil.js'
import Formatter from '../../utility/formatterUtil.js'
import isEmpty from '../../utility/isEmpty.js'
import Logger from '../../utility/loggerUtil.js'
import SessionRecord from '../../utility/sessionRecordUtil.js'

// Vuex
import { defaultObj } from './state.js'

export default {
  updateCustomerInfo (state, data) {
    if (!isEmpty(data.email)) {
      state.email = data.email
      SessionRecord.setUserIdentifier(data.email, AnalyticsConstants.propName.email)
    }

    if (data.cellPhoneNumber !== undefined) {
      state.cellPhoneNumber = data.cellPhoneNumber
      SessionRecord.setUserIdentifier(Formatter.stripPhoneNumber(data.cellPhoneNumber), AnalyticsConstants.propName.phone)
    }

    setManualEntryValue(state, data, 'firstName', 'first_name')
    setManualEntryValue(state, data, 'middleName', 'middle_name')
    setManualEntryValue(state, data, 'lastName', 'last_name')
    setManualEntryValue(state, data, 'suffixName', 'suffix_name')
    setManualEntryValue(state, data, 'address', 'address')

    if (data.optionalAddress !== undefined) {
      state.optionalAddress = data.optionalAddress
    }

    setManualEntryValue(state, data, 'city', 'city')
    setManualEntryValue(state, data, 'zip', 'zip')
    setManualEntryValue(state, data, 'state', 'state')

    if (data.mailingAddress !== undefined) {
      state.mailingAddress = data.mailingAddress
    }

    if (data.mailingOptionalAddress !== undefined) {
      state.mailingOptionalAddress = data.mailingOptionalAddress
    }

    if (data.mailingCity !== undefined) {
      state.mailingCity = data.mailingCity
    }

    if (data.mailingZip !== undefined) {
      state.mailingZip = data.mailingZip
    }

    if (data.mailingState !== undefined) {
      state.mailingState = data.mailingState
    }

    if (data.addressSameAsMailingAddress !== undefined) {
      state.addressSameAsMailingAddress = data.addressSameAsMailingAddress
    }

    setManualEntryValue(state, data, 'dateOfBirth', 'date_of_birth')

    if (data.isCustomerInBankruptcy !== undefined) {
      state.isCustomerInBankruptcy = data.isCustomerInBankruptcy
    }

    if (data.userName !== undefined) {
      state.userName = data.userName
    }

    if (data.maritalStatus !== undefined) {
      state.maritalStatus = data.maritalStatus
    }

    setManualEntryValue(state, data, 'idSelection', 'id_selection')
    data.idNumber = isEmpty(data.idNumber) ? data.idNumber : data.idNumber.replace(/[^0-9a-z]/gi, '')
    setManualEntryValue(state, data, 'idNumber', 'id_number')
    setManualEntryValue(state, data, 'idState', 'id_state')
    setManualEntryValue(state, data, 'idExpiration', 'id_expiration')

    if (data.race !== undefined) {
      state.race = data.race
    }

    setManualEntryValue(state, data, 'weight', 'weight')
    setManualEntryValue(state, data, 'height', 'height')
    setManualEntryValue(state, data, 'sex', 'sex')

    if (data.tin !== undefined) {
      state.tin = data.tin
    }

    if (data.noTin !== undefined) {
      state.noTin = data.noTin
    }

    if (data.alienRegistrationNumber !== undefined) {
      state.alienRegistrationNumber = data.alienRegistrationNumber
    }

    if (data.activeDuty !== undefined) {
      state.activeDuty = data.activeDuty
    }

    if (data.optIn !== undefined) {
      state.optIn = data.optIn
    }

    if (data.requestedAmount !== undefined) {
      state.requestedAmount = data.requestedAmount
    }

    if (data.selectedRetailStore !== undefined) {
      state.selectedRetailStore = data.selectedRetailStore
    }

    if (data.applicationId !== undefined) {
      state.applicationId = data.applicationId
      Analytics.setUserProperty(AnalyticsConstants.userProperties.applicationId, data.applicationId)
    }

    if (data.applicationStatus !== undefined) {
      state.applicationStatus = data.applicationStatus
    }

    if (data.customerId !== undefined) {
      state.customerId = data.customerId
      Analytics.setUserProperty(AnalyticsConstants.userProperties.customerId, data.customerId)
    }

    if (data.appraisalId !== undefined) {
      state.appraisalId = data.appraisalId
    }

    if (data.appraisalStatus !== undefined) {
      state.appraisalStatus = data.appraisalStatus
    }

    if (data.approvedAmount !== undefined) {
      state.approvedAmount = data.approvedAmount
    }

    if (data.identityVerified !== undefined) {
      state.identityVerified = data.identityVerified
    }

    if (data.applicationSubmitted !== undefined) {
      state.applicationSubmitted = data.applicationSubmitted
    }

    if (data.signatureName !== undefined) {
      state.signatureName = data.signatureName
    }

    if (data.newCustomer !== undefined) {
      state.newCustomer = data.newCustomer
    }

    if (data.trafficChannel !== undefined) {
      state.trafficChannel = data.trafficChannel
    }

    if (data.invitationCode !== undefined) {
      state.invitationCode = data.invitationCode
    }

    if (data.shortFormLoanType !== undefined) {
      state.shortFormLoanType = data.shortFormLoanType
    }

    if (data.language !== undefined) {
      state.language = data.language
    }

    if (data.hasTitle !== undefined) {
      state.hasTitle = data.hasTitle
    }

    if (data.hasTitleWithLender !== undefined) {
      state.hasTitleWithLender = data.hasTitleWithLender
    }

    if (data.allowSelfAppraisal !== undefined) {
      state.allowSelfAppraisal = isEmpty(data.allowSelfAppraisal) ? undefined : data.allowSelfAppraisal !== false && data.allowSelfAppraisal !== 'false'
    }

    if (data.referralCode !== undefined) {
      state.referralCode = data.referralCode
    }

    if (data.employmentLength !== undefined) {
      state.employmentLength = data.employmentLength
    }

    if (data.employmentPerWeek !== undefined) {
      state.employmentPerWeek = data.employmentPerWeek
    }

    if (data.customerHasSeenCppVideo !== undefined) {
      state.customerHasSeenCppVideo = data.customerHasSeenCppVideo
    }

    if (data.routingNum !== undefined) {
      state.routingNum = data.routingNum
    }

    if (data.accountNum !== undefined) {
      state.accountNum = data.accountNum
    }

    if (data.confirmAccountNum !== undefined) {
      state.confirmAccountNum = data.confirmAccountNum
    }

    if (data.tosAccepted !== undefined) {
      state.tosAccepted = data.tosAccepted
    }

    if (data.bankAccountEntryStatus !== undefined) {
      state.bankAccountEntryStatus = data.bankAccountEntryStatus
    }

    if (data.bankName !== undefined) {
      state.bankName = data.bankName
    }

    if (data.loanProduct !== undefined) {
      state.loanProduct = data.loanProduct
    }

    if (data.mlvVerified !== undefined) {
      state.mlvVerified = data.mlvVerified
    }

    if (data.newCustomerForAnalytics !== undefined) {
      state.newCustomerForAnalytics = data.newCustomerForAnalytics
    }

    if (data.scanIdBarcodeData !== undefined) {
      state.scanIdBarcodeData = data.scanIdBarcodeData
    }

    if (data.ccfiStoreNumber !== undefined) {
      state.ccfiStoreNumber = data.ccfiStoreNumber
    }

    if (data.returnCustIndicator !== undefined) {
      state.returnCustIndicator = data.returnCustIndicator
    }

    if (data.custLoanTypeSelection !== undefined) {
      state.custLoanTypeSelection = data.custLoanTypeSelection
    }

    if (data.existingFlexLoan !== undefined) {
      state.existingFlexLoan = data.existingFlexLoan
    }

    if (data.leadId !== undefined) {
      state.leadId = data.leadId
    }
  },

  updatePhoneVerified (state, data) {
    if (data.phoneNumberVerified !== undefined) {
      state.phoneNumberVerified = data.phoneNumberVerified
    }

    if (data.optIn !== undefined) {
      state.optIn = data.optIn
    }
  },

  updateCustomerScanData (state, data) {
    setScannedIdValue(state, data, 'firstName', 'first_name')
    setScannedIdValue(state, data, 'middleName', 'middle_name')
    setScannedIdValue(state, data, 'lastName', 'last_name')
    setScannedIdValue(state, data, 'suffixName', 'suffix_name')
    setScannedIdValue(state, data, 'dateOfBirth', 'date_of_birth')
    setScannedIdValue(state, data, 'address', 'address')
    setScannedIdValue(state, data, 'zip', 'zip')
    setScannedIdValue(state, data, 'city', 'city')
    setScannedIdValue(state, data, 'state', 'state')
    setScannedIdValue(state, data, 'weight', 'weight')
    setScannedIdValue(state, data, 'height', 'height')
    setScannedIdValue(state, data, 'sex', 'sex')
    setScannedIdValue(state, data, 'idSelection', 'id_selection')
    setScannedIdValue(state, data, 'idState', 'id_state')
    data.idNumber = isEmpty(data.idNumber) ? data.idNumber : data.idNumber.replace(/[^0-9a-z]/gi, '')
    setScannedIdValue(state, data, 'idNumber', 'id_number')
    setScannedIdValue(state, data, 'idExpiration', 'id_expiration')

    if (data.applicationId !== undefined) {
      state.applicationId = data.applicationId
      Analytics.setUserProperty(AnalyticsConstants.userProperties.applicationId, data.applicationId)
    }

    if (data.scanIdBarcodeData !== undefined) {
      state.scanIdBarcodeData = data.scanIdBarcodeData
    }
  },

  updateGeolocationCheck (state, data) {
    if (data.customerAddressGeoChecked !== undefined) {
      state.customerAddressGeoChecked = data.customerAddressGeoChecked
    }

    if (data.idStateGeoChecked !== undefined) {
      state.idStateGeoChecked = data.idStateGeoChecked
    }
  },

  saveReferences (state, data) {
    state.referencesList = data.referencesList
  },

  reset (state) {
    state = Object.assign(state, defaultObj)
  }
}

const isStringChanging = (value1, value2) => {
  const value1Empty = isEmpty(value1)
  const value2Empty = isEmpty(value2)

  if (value1Empty || value2Empty) { // If either value is empty, no changing is occurring
    return false
  }

  return value1.toString().toLowerCase() !== value2.toString().toLowerCase()
}

const setScannedIdValue = (state, data, propertyName, analyticsId) => {
  try {
    const dataValue = data[propertyName]

    if (dataValue !== undefined) {
      if (isStringChanging(state[propertyName], dataValue)) {
        Analytics.logEvent(AnalyticsConstants.eventName.changeContent, { item_id: analyticsId, item_method: 'id_scan_auto_overwrite', value: dataValue })
      }

      state[propertyName] = dataValue
      state.scanIdData[propertyName] = dataValue
    }
  } catch (error) {
    Logger.error(`Error setting scan ID value prop ${propertyName}`)
    Logger.debug(error)
    throw error
  }
}

const setManualEntryValue = (state, data, propertyName, analyticsId) => {
  try {
    const dataValue = data[propertyName]

    if (dataValue !== undefined) {
      if (isStringChanging(state.scanIdData[propertyName], dataValue)) {
        Analytics.logEvent(AnalyticsConstants.eventName.changeContent, { item_id: analyticsId, item_method: 'id_scan_manual_overwrite', value: dataValue })
      }

      state[propertyName] = dataValue
      state.scanIdData[propertyName] = undefined // Reset scanned data property to change event only fires the first time
    }
  } catch (error) {
    Logger.error(`Error setting manual entry value prop ${propertyName}`)
    Logger.debug(error)
    throw error
  }
}
